/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChemoEncontersListAliases {
  CHEMO_PROTOCOL_CARD_0 = 'chemo-protocol-card-0',
  CONTEXTUAL_CARDS = 'contextual-cards',
  DECK_CHEMO_PROTOCOL_CARD = 'deck-chemo-protocol-card',
  FETCH_CHEMO_PROTOCOL_CARD = 'fetch-chemo-protocol-card',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  LAYOUT_CHEMO_ENCONTERS_LIST = 'layout-chemo-enconters-list',
  MEDIA_QUERY_CHEMO_PROTOCOL_CARD = 'media-query-chemo-protocol-card',
  PANEL_CHEMO_PROTOCOL_CARD = 'panel-chemo-protocol-card',
  ROOT_LAYOUT = 'root-layout',
}
export { ChemoEncontersListAliases };
